class Unauthorized extends Error {
  constructor(message) {
    super(message);
    this.name = 'FunkeUnauthorized';
  }
}
export default Unauthorized;
